export default {
  TableHeadGamesManagement: [
    [
      {
        displayName: 'games_management.table_head.no',
      },
      {
        displayName: 'games_management.table_head.game_name',
      },
      {
        displayName: 'games_management.table_head.game_id',
      },
      {
        displayName: 'games_management.table_head.code',
      },
      {
        displayName: 'games_management.table_head.partner',
      },
      {
        displayName: 'games_management.table_head.sort',
      },
      {
        displayName: 'games_management.table_head.kind',
      },
    ],
  ],
  TableHeadEditSort:[
    [
      {
        displayName: 'games_management.table_head.edit',
      },
      {
        displayName: 'games_management.table_head.no',
      },
      {
        displayName: 'games_management.table_head.game_name',
      },
      {
        displayName: 'games_management.table_head.game_id',
      },
      {
        displayName: 'games_management.table_head.code',
      },
      {
        displayName: 'games_management.table_head.partner',
      },
      {
        displayName: 'games_management.table_head.sort',
      },
      {
        displayName: 'games_management.table_head.kind',
      },
    ],
  ],
};
